{
  "note": "Figure colours as the C64 had them (spec 05 §4, research R§1-R§4): each ramp is opened out from one C64 colour number. Sprite table $AB63 by monster type; players P1 green, P2 cyan; angry light red; bubbles light green (colour RAM $0D). Set \"figures\": \"arcade\" on a Palette to use core.json's arcade-style ramps instead.",
  "ramps": {
    "bub": 5,
    "bob": 3,
    "zen": 12,
    "hidegons": 15,
    "banebou": 5,
    "pulpul": 13,
    "monsta": 4,
    "drunk": 5,
    "robe": 3,
    "invader": 15,
    "angry": 10,
    "bubble": 13
  }
}
